import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_ANALYTICS_AI } from "@/lib/service-content/faqs/analytics-ai";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/analytics-ai";

export const Route = createFileRoute("/analytics-ai")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify Analytics & Applied AI: Measurement and Decision Systems · Shugert",
    description: "Shopify analytics, GA4 reconciliation, customer measurement and applied AI built around explicit definitions, validation and human decision ownership.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-default-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Analytics & AI", path: PATH }]),
      faqJsonLd(FAQS_ANALYTICS_AI.en),
      serviceJsonLd({
        name: "Shopify Analytics & Applied AI",
        description: "Measurement contracts, Shopify and GA4 reconciliation, decision surfaces and validated applied-AI prototypes with explicit human ownership.",
        path: PATH,
        serviceType: "E-commerce Analytics and Applied AI",
        minPrice: 1500,
        unit: "PROJECT",
        deliverables: ["Commercial question inventory", "Measurement contract", "Data and event plan", "Decision surface", "Validated model or automation brief when justified"],
        locale: "en",
      }),
    ],
  }),
});
